module.exports = __webpack_public_path__ + "static/img/avatar.e0fc63b.jpg";


//////////////////
// WEBPACK FOOTER
// ./resume/avatar.jpg
// module id = veQb
// module chunks = 1